module.exports = __webpack_public_path__ + "img/dygc-pro.533d482a.jpeg";